import React from "react"

const Footer = () => {
  const socialLinks = [
    {
      name: "YouTube",
      url: "https://www.youtube.com/@AlurenDynamics"
    },
    {
      name: "Threads",
      url: "https://www.threads.com/@alurendynamics"
    },
    {
      name: "Instagram", 
      url: "https://www.instagram.com/aluren.inc"
    },
    {
      name: "X (Twitter)",
      url: "https://x.com/AlurenDynamics"
    },
    {
      name: "Facebook",
      url: "https://www.facebook.com/profile.php?id=61586061127086"
    },
    {
      name: "Email",
      url: "mailto:contact@alurendynamics.com"
    }
  ];

  const linkStyle = {
    color: '#ffffff',
    textDecoration: 'none',
    margin: '0 0.75rem',
    transition: 'color 0.3s ease',
    fontSize: '14px'
  };

  const linkHoverStyle = {
    color: '#c4c4c4'
  };

  return (
    <footer style={{
      backgroundColor: '#000',
      color: '#ffffff',
      padding: '2rem 1.5rem',
      marginTop: 0,
      textAlign: 'center',
      fontSize: '14px'
    }}>
      <div style={{ marginBottom: '1rem' }}>
        <p style={{ marginBottom: '0.75rem', fontWeight: '300' }}>Find us on social media:</p>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          flexWrap: 'wrap',
          gap: '0.5rem'
        }}>
          {socialLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
              onMouseOver={(e) => e.target.style.color = linkHoverStyle.color}
              onMouseOut={(e) => e.target.style.color = linkStyle.color}
            >
              {link.name}
            </a>
          ))}
        </div>
      </div>
      <p style={{ fontWeight: '300' }}>&copy; {new Date().getFullYear()} Aluren. All rights reserved.</p>
    </footer>
  );
}

export default Footer;